import { Grid } from "@mui/material";
import * as React from "react";
import {
  AutocompleteArrayInput,
  BooleanInput,
  DateTimeInput,
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
  AutocompleteInput
} from "react-admin";
import { Edit, FormTab, TabbedForm } from "src/enterprise/ra-rbac";
import { PrivacyEnum, StatusEnum } from "../../common/enum";
import Transformer from "../../common/Transformer";
import { FileInput } from "../../components/file-input/FileInput";
import { TinyMCEContentInput } from "../../components/input";
import { ArticleEditComponent } from "./ArticleComponent";

export const ArticleEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: [
        "id",
        "createdBy",
        "createdAt",
        "updatedAt",
        "updatedBy",
        "tagIds",
        "categoryIds",
      ],
      update: {
        author: data.author.id,
        tags: data["tag_ids"],
        categories: data["category_ids"],
        featured: data.featured !== null ? data.featured.toString() : "false",
        publishedAt:
          data.publishedAt !== undefined
            ? data.publishedAt.toISOString()
            : data["published_at"],
      },
    });
    return data;
  };

  return (
    <Edit
      component={ArticleEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={6} md={2} lg={1}>
              <TextInput disabled source="id" />
            </Grid>
            <Grid item>
              <BooleanInput
                label="Featured"
                source="featured"
                options={undefined}
              />
            </Grid>
          </Grid>

          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item md={12}>
              <TextInput source="slug" sx={{ marginTop: "8px" }} validate={required()}/>
            </Grid>
            <Grid item md={12}>
              <TextInput source="title" validate={required()} sx={{ marginTop: "8px" }} />
            </Grid>
            <Grid item lg={6}>
              <ReferenceInput
                source="author.id"
                reference="admin/users"
                filter={{ "roles.like": "ROLE_ADMIN" }}
                
              >
                <AutocompleteInput
                  optionText={(record) => record.first_name+" "+record.last_name+" ("+record.email+")"}
                  size="small"
                  label="Author"
                  validate={required()}
                />
              </ReferenceInput>
            </Grid>

            <Grid item lg={6}>
              <DateTimeInput label="Published at" source="published_at" />
            </Grid>
            <Grid item lg={6}>
              <SelectInput source="status" choices={StatusEnum} validate={required()}/>
            </Grid>
            <Grid item lg={6}>
              <SelectInput source="privacy" choices={PrivacyEnum} validate={required()}/>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12}>
              <TinyMCEContentInput source="content" required base64 fullWidth />
            </Grid>
            <Grid item sm={12}>
              <TinyMCEContentInput source="excerpt" required base64 fullWidth />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="SEO" name="seo">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_title" />
            </Grid>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_description" multiline rows={4} />
            </Grid>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_keywords" multiline rows={4} />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Featured Image" name="image">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <FileInput
                  source="image"
                  fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
                  multiple={false}
              />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Categories" name="categories">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <ReferenceArrayInput
                source="category_ids"
                reference="admin/article/categories"
                children={
                  <AutocompleteArrayInput
                    optionText="name"
                    size="small"
                    sx={{ minWidth: "35vw" }}
                  />
                }
              />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Tags" name="tags">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <ReferenceArrayInput
                source="tag_ids"
                reference="admin/article/tags"
                children={
                  <AutocompleteArrayInput
                    optionText="name"
                    size="small"
                    sx={{ minWidth: "35vw" }}
                  />
                }
              />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Custom CSS" name="css">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={12}>
              <TextInput source="css" multiline fullWidth minRows="15" maxRows="30"/>
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
